export default () => ({
  timeline: {
    width: '60%',
    maxWidth: '60%',
    margin: 0,
    padding: 0,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  timelineDot: {
    width: 25,
    height: 25,
    margin: 0,
    position: 'relative',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  timelineItem: {
    minHeight: 0,
    '&:before': {
      display: 'none',
    },
  },
  checkMarkIcon: {
    width: 15,
    height: 15,
    fill: '#ffffff',
  },
});
